import { supabase } from './supabase';

const SENT = new Set<string>();

/**
 * After a video job finishes, ask the Edge Function to email the user when
 * generation took more than 2 minutes. Idempotent on the server.
 */
export function notifyVideoReadyEmail(jobId: string): void {
  const id = String(jobId || '').trim();
  if (!id || SENT.has(id)) return;
  SENT.add(id);
  void supabase.functions.invoke('notify-video-ready', {
    body: { job_id: id },
  }).then(({ error }) => {
    if (error) {
      SENT.delete(id);
      console.warn('notify-video-ready', error.message);
    }
  }).catch((err) => {
    SENT.delete(id);
    console.warn('notify-video-ready', err);
  });
}
